import React, { Component } from "react";
import { ToastsStore } from "react-toasts";
import { callApi } from "../../utils/api";
import VettingLoginForm from "./VettingLoginForm";
import moment from "moment";
import { getExtentUnits } from "../../utils/staticData";
import { message, Radio } from "antd";
import isEmpty from 'lodash/isEmpty';
import { cloneDeep } from "lodash";
import VettingUploadDocument from "./vettingUploadDocument";
import { toast } from "react-toastify";
import { compressPdf } from "../PdfCompress/PdfCompressor";
import { ADMIN_ROLE } from "../../utils/role";
import { hasPageAccess } from "../../utils/pagePermissionService";
import { defaultLoginBillingState, stripLoginBillingServiceChargesFromPayload, validateLoginBillingFields } from "../../utils/loginBillingUtils";

declare var $: any;
interface AllProps {
    match: any;
    history: any;
    location: any;
}
export interface PropertyOwnerItem {
    id?: string;
    name: string;
    mobile: string;
    email: string;
}
interface Title {
    isValid: boolean;
    doc_no: string;
    doc_type: string;
    name: string;
    schedule: string;
    survey_no_extent: {
        extent: string;
        survey_no: string;
        sur_extent_unit: string;
    }[];
}
interface PrivatelistItem {
    id: string;
    name: string;
    mobile: string;
    email: string;
    id_key: string;
}

const initialState = {
    bankName: "",
    bankid: '',
    bank_private: "",
    name: "",
    file_id: "",
    property_owner_name: "",
    borrower_name: "",
    coApplicant: "",
    contact_number: "",
    loan_amount: "",
    app_id: "",
    redirect: false,
    manage: false,
    isNext: false,
    isLoading: false,
    doctype: "",
    doctypes: [],
    docToPreview: "",
    isNewFile: false,
    categoriesList: [],
    required: false,
    isbtnload: false,
    products: [],
    filteredProduct: [],
    product_id: "",
    selected_product_id: "",
    lawhands_branch: "",
    branch: "",
    bank_name: "",
    global_search: "",
    deeds: [],
    type: "title_deed",
    opinion_type: "1",
    privateList: [] as PrivatelistItem[],
    userHintAboutFile: "",
    outreason: "",
    selectVal: false,
    file_idfk: '',
    1: [],
    logintype: '',
    existingFileNo: '',
    file_status: '',
    showForm: false,
    frontOfficeLoading: false,
    existLoading: false,
    searchEdit: false,
    brolist: [],
    base: [],
    isReset: false,
    branches: [],
    filteredBranches: [],
    isGlobalPdfCompress: '',
    globalPdfCompressQuality: '',
    isFrontOfficePdfCompressShow: '',
    isSroEcPdfCompressQuality: '',
    isOnlineEcPdfCompressQuality: '',
    ...defaultLoginBillingState,
};

class AddVettingFile extends Component<AllProps> {
    documentFormat = {
        base: "",
        base_url: "",
        doc_path: "",
        docNoYear: "",
        particular: "xerox",
        type: "",
        details: {},
        fileNames: [],
        isSavedFile: false,
        isValid: true,
        doc_type: "",
        isPdfCompress: 'off',
    };
    firstdocumenttitledeed = {
        base: "",
        base_url: "",
        doc_path: "",
        docNoYear: "",
        particular: "xerox",
        type: "title_deed",
        details: {},
        fileNames: [],
        isSavedFile: false,
        isValid: true,
        doc_type: "",
        isPdfCompress: 'off',
    };
    firstdocumentsaleagree = {
        base: "",
        base_url: "",
        doc_path: "",
        docNoYear: "",
        particular: "xerox",
        type: "sale_agreement",
        details: {},
        fileNames: [],
        isSavedFile: false,
        isValid: true,
        doc_type: "",
        isPdfCompress: 'off',
    };
    state = { ...initialState, file_idfk: this.props.match.params.id };

    async componentDidMount() {
        const extentUnits = getExtentUnits();
        this.setState({ extentUnits });
        this.fetchPdfSettings();

        this.listBankproduct();
        this.getDocTypes();
        this.getCategories();
        this.getOutTime();
        const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
        if (!hasHide) {
            this.ouTime();
        }
        const isNewFile = Number(this.props.match.params.id) === 0;
        const vettingSearchEdit = localStorage.getItem("vetting_search_edit");
        const isVettingSearchEdit = vettingSearchEdit === "true";

        if (!isNewFile) {
            setTimeout(() => {
                this.getFileDetail(this.props.match.params.id);
            }, 1000);
        }
        this.setState({
            isNewFile,
            searchEdit: isVettingSearchEdit,
            ...(isVettingSearchEdit ? { logintype: "1", showForm: true } : {}),
        });
        this.getDeeds();
    }
    fetchPdfSettings = () => {
        callApi("POST", "pdf_category.php")
            .then((res) => res.data)
            .then((response: any) => {
                if (response.result && response.data) {
                    const isGlobalPdfCompress = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.status == '1';
                    const globalPdfCompressQuality = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.quality;
                    const isFrontOfficePdfCompressShow = response.data['Pdf document']?.find((item: any) => item.name == 'In Vetting Show/Hide')?.status == '1';
                    const isSroEcPdfCompressQuality = response.data['Pdf Category']?.find((item: any) => item.name == 'SRO Encumbrance Certificate')?.quality;
                    const isOnlineEcPdfCompressQuality = response.data['Pdf Category']?.find((item: any) => item.name == 'Online Encumbrance Certificate')?.quality;
                    this.setState({
                        isGlobalPdfCompress,
                        isFrontOfficePdfCompressShow,
                        globalPdfCompressQuality,
                        isSroEcPdfCompressQuality,
                        isOnlineEcPdfCompressQuality
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                ToastsStore.error("Failed to load PDF settings");
            });
    };
    getDeeds = () => {
        callApi("POST", "deed_master_get.php", { category: this.state.type })
            .then(res => res.data)
            .then(response => {
                if (response.data && response.data.length) {
                    const deeds = response.data;
                    this.setState({ deeds });
                }
            })
            .catch(err => {
                console.log(err);
            });
    };
    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            window.location.reload();
        }
    }
    componentWillUnmount() {
        localStorage.setItem('global_search', JSON.stringify(false));
        localStorage.setItem('edit_global_search', JSON.stringify(false));
        localStorage.removeItem('vetting_search_edit');
        localStorage.removeItem('vetting_search_return_url');
    }

    listBankproduct = () => {
        this.setState({ isFileRefresh: false });
        callApi("GET", "bank_product_get.php")
            .then(res => res.data)
            .then(response => {
                const files = response.data;
                this.setState({ products: files });
            })
            .catch(err => {
                console.log(err);
            });
    };
    previousPop = () => {
        $("#out_reason").modal("show");
        $("#another-reason").modal("hide");
    }
    BacktoFile = () => {
        $("#out_reason").modal("hide");
        const fileid1: any = localStorage.getItem("currentfileId");

        this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
    }
    getOutTime = () => {
        let date = new Date();
        let stratTime = date.getTime();
        localStorage.setItem("startTime", JSON.stringify(stratTime))
        let outDate = date.toLocaleDateString();
        localStorage.setItem("OutDateGet", JSON.stringify(outDate));
        var Railway = date.getMinutes();
        if (Railway < 10) {
            var TotalMinutes = "0" + Railway;
            let ouTtime = date.getHours() + ":" + TotalMinutes;
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }
        else {
            let ouTtime: any = date.getHours() + ":" + date.getMinutes();
            localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
        }

    }
    ouTime = () => {
        if (localStorage.getItem("currentfileId")) {
            $("#out_reason").modal("show");
        }
    }
    outimeGet = () => {
        this.setState({ isLoading: true });
        const fileid1: any = localStorage.getItem("currentfileId");
        const userid1: any = localStorage.getItem("user1");
        const inreason: any = localStorage.getItem("in_reason");
        const intime: any = localStorage.getItem("IntimeGet");
        const outtime: any = localStorage.getItem("outtimeGet");
        const outdate: any = localStorage.getItem("OutDateGet");
        const secondsSpent = moment(outtime, "HH:mm").diff(moment(intime, "HH:mm"), 'seconds');
        const insertId: any = localStorage.getItem("ProcessEodInsertID");
        if (this.state.outreason == "") {
            this.setState({ selectVal: true });
        }
        else {
            let obj = {
                "file_id": JSON.parse(fileid1),
                "user_id": JSON.parse(userid1),
                "in_reason": JSON.parse(inreason),
                "out_reason": this.state.outreason,
                "intime": JSON.parse(intime),
                "outtime": JSON.parse(outtime),
                "insert_date": JSON.parse(outdate),
                "total_seconds": secondsSpent,
                "insert_id": insertId
            }
            callApi("POST", "process_eod_insert.php", obj)
                .then(res => res.data)
                .then(response => {
                    this.setState({ isLoading: false });
                    localStorage.removeItem("in_reason");
                    localStorage.removeItem("outreason");
                    localStorage.removeItem("IntimeGet");
                    localStorage.removeItem("OutDateGet");
                    $("#out_reason").modal("hide");
                    $("#another-reason").modal("hide");
                    ToastsStore.success("Your Reason Saved Successfully");
                    let process_officerId: any = localStorage.getItem("process_office_id");
                    let process_officer_id = JSON.parse(process_officerId);
                    const userid1: any = localStorage.getItem("user1");
                    let user_id = JSON.parse(userid1);
                    const take_file: any = localStorage.getItem("takenfile_id");
                    const user: any = localStorage.getItem("user");
                    const getfileId: any = localStorage.getItem("currentfileId");
                }).catch((err) => {
                    console.log(err);
                    this.setState({ isLoading: false });
                    ToastsStore.error("Your Reason Not Stored");
                })
        }
    }
    onchangeReason = (e: any) => {

        if (e.target.value == "Other") {
            this.setState({ in_reason: "", selectVal: false })
            $("#out_reason").modal("hide");
            $("#another-reason").modal("show");
        }
        else if (e.target.value == "select") {
            this.setState({ setResponse: false })
        }
        else {
            this.setState({ [e.target.name]: e.target.value, selectVal: false });
        }
    };
    onchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value.replace(/\s+/g, ' ').trim(), selectVal: false });
    };
    getCategories = () => {
        callApi("POST", "category.php")
            .then((res) => res.data)
            .then((response) => {
                this.setState({ categoriesList: response.data });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    getFileDetail = (fileId: any, isExistFile?: any) => {
        this.setState({ frontOfficeLoading: true });
        const API = isExistFile ? "front_office_get.php" : "vetting_front_office_get.php";
        callApi("POST", API, { id: fileId })
            .then((res) => res.data)
            .then((response) => {
                if (
                    response &&
                    response?.data &&
                    response?.data?.length &&
                    response?.data[0]?.arr &&
                    response?.data[0]?.arr?.length
                ) {

                    const state = response?.data[0]?.arr[0];
                    state.privateList = response?.data[0]?.Dsa;
                    state.brolist = response?.data[0]?.brolist;
                    if (state.file_status == "5" || state.file_status == "11" || !isExistFile) {
                        if (!isExistFile) {
                            state.base = !isExistFile ? (response.data[0].base
                                ? response?.data[0]?.base?.map((base) => {
                                    return {
                                        ...base,
                                        isSavedFile: true,
                                    };
                                })
                                : []) : [];
                        } else {
                            state.contact_number = response.data[0].contact_number;
                            state.loan_amount = response.data[0].loan_amount;
                        }
                        this.filterProduct(response?.data[0]?.arr[0]?.bank_name);
                        this.setState({
                            ...state,
                            showForm: true,
                            frontOfficeLoading: false,
                            existLoading: isExistFile ? true : false,
                            searchEdit: this.state.searchEdit,
                            logintype: this.state.searchEdit ? "1" : this.state.logintype,
                        });
                    } else {
                        this.setState({ showForm: false, frontOfficeLoading: false, existLoading: false });
                        toast.error("This existing file is not completed, so you can't proceed for vetting");
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ showForm: false, frontOfficeLoading: false });
            });
    };
    filterProduct = bankid => {
        if (bankid) {
            const filteredProduct = this.state.products.filter(
                (branch: any) => branch.bank_id === bankid
            );
            const state = this.state;
            state.filteredProduct = filteredProduct;
            this.setState({ ...state }, () => {
                // this.ifIdBankBranches(bankid)
            });
        } else {
            this.setState({ product_id: "" });
        }
    };
    ifIdfilterBranches = bankid => {
        const filteredBranches = this.state.branches.filter((branch: any) => branch.bank_id === bankid && branch.product_id === this.state.product_id);
        const state = this.state;
        state.filteredBranches = filteredBranches;
        this.setState({ ...state }, () => { });
    };

    ifIdBankBranches(bankid) {

        callApi("GET", "bank_branch_get.php")
            .then(res => res.data)
            .then(result => {
                this.setState({ branches: result.data });
                if (!isEmpty(bankid)) {
                    this.ifIdfilterBranches(bankid);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }
    getDocTypes = () => {
        callApi("GET", "type.php")
            .then((res) => res.data)
            .then((response) => {
                if (response && response.data && response.data.length) {
                    this.setState({ doctypes: response.data });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    navigateToDocs = (state: any) => {
        this.setState({ ...state, ...state });
        this.setState({ bankid: state.bank_name })
    };

    handleChange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    newvalidateDocuments = () => {
        let base: any = this.state.base;
        let isValid = true;
        const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', 'Online Encumbrance Certificate'];
        for (let i = 0; i < base.length; i++) {
            const document = base[i];
            if (invalidDocuments.includes(document.doc_type)) {
                base[i].isValid = true;
            }
            else {
                if (document.type == "deed" || document.type == "mother_doc" || document.type == "title_deed" || document.type == "ec_doc") {
                    if (!document.docNoYear || !document.doc_type || !document.type || !document.particular) {
                        isValid = false;
                        base[i].isValid = false;
                    } else {
                        base[i].isValid = true;
                    }
                } else if (document.type == "rev_rec_doc" || document.type == "sale_agreement") {
                    if (!document.doc_type || !document.type || !document.particular) {
                        isValid = false;
                        base[i].isValid = false;
                    } else {
                        base[i].isValid = true;
                    }
                }

                else {
                    isValid = false;
                    base[i].isValid = false;
                }
            }
        }
        return isValid;
    };

    validateDocuments = () => {
        let base: any = this.state.base;
        let isValid = true;
        const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', 'Online Encumbrance Certificate'];
        for (let i = 0; i < base.length; i++) {
            const document = base[i];
            if (invalidDocuments.includes(document.doc_type)) {
                base[i].isValid = true;
            }
            else {
                if (document.type == "deed" || document.type == "mother_doc" || document.type == "title_deed" || document.type == "ec_doc") {
                    if (!document.docNoYear || !document.doc_type || !document.type || !document.particular || !document.base) {
                        isValid = false;
                        base[i].isValid = false;
                    } else {
                        base[i].isValid = true;
                    }
                } else if (document.type == "rev_rec_doc" || document.type == "sale_agreement") {
                    if (!document.doc_type || !document.type || !document.particular || !document.base) {
                        isValid = false;
                        base[i].isValid = false;
                    } else {
                        base[i].isValid = true;
                    }
                }
                else {
                    isValid = false;
                    base[i].isValid = false;
                }
            }
        }
        return isValid;
    };

    validateRequiredFields = (e, status) => {
        this.setState({ required: true });
        let isValid;

        const {
            property_owner_name,
            borrower_name,
            coApplicant,
            bank_name,
            product_id,
            branch,
            lawhands_branch,
            contact_number,
            loan_amount,
            app_id,
            existingFileNo,
            isNewFile
        } = this.state;

        if (isNewFile) {
            isValid = this.newvalidateDocuments();
        } else {
            isValid = this.validateDocuments();
        }

        const isExistingFileValid = !isEmpty(existingFileNo) ? existingFileNo !== "" : true;

        if (
            isValid &&
            property_owner_name &&
            borrower_name &&
            // coApplicant &&
            bank_name &&
            product_id &&
            branch &&
            lawhands_branch &&
            contact_number &&
            loan_amount &&
            app_id &&
            isExistingFileValid
        ) {
            const billingError = validateLoginBillingFields(this.state, this.state.billTypes || [], "Vetting Fees");
            if (billingError) {
                ToastsStore.error(billingError);
                return;
            }
            this.saveFile(e, status);
        } else {
            ToastsStore.error("Please fill all the required fields");
        }
    };

    saveFile = (e, status) => {
        e.preventDefault();
        this.setState({ isLoading: true });
        const state: any = this.state;
        // delete state.branches;
        // delete state.filteredBranches;
        delete state.required;
        delete state.selectVal;
        delete state.redirect;
        delete state.products;
        delete state.manage;
        // delete state.logintype;
        // delete state.lawhandsBranches;
        delete state.isbtnload;
        delete state.isNext;
        // delete state.isNewFile;
        delete state.isLoading;
        delete state.isFileRefresh;
        delete state.global_search;
        // delete state.frontOfficeLoading;
        // delete state.filteredProduct;
        // delete state.filteredBranchesproduct;
        // delete state.extentUnits;
        // delete state.doctypes;
        // delete state.deeds;
        // delete state.categoriesList;
        // delete state.banks;
        // Remove 'doc_path' from each object in the base array
        if (Array.isArray(state.base)) {
            state.base = state.base.map(({ doc_path, ...rest }) => rest);
        }
        state.id = Number(this.props.match.params.id);
        if (this.state.searchEdit) {
            state.search_edit = true;
            state.file_status = this.state.file_status;
        } else {
            state.file_status = status;
        }
        const user: any = localStorage.getItem("user");
        state.userId = user ? JSON.parse(user)["userId"] : "";

        const API = state.id ? "vetting_file_update" : "vetting_file_create";
        callApi("POST", `${API}.php`, stripLoginBillingServiceChargesFromPayload(state))
            .then((res) => res.data)
            .then((response) => {
                if (response.success) {
                    ToastsStore.success(response.message);
                    if (this.state.searchEdit) {
                        const returnUrl = localStorage.getItem("vetting_search_return_url") || "/dashboard";
                        localStorage.removeItem("vetting_search_edit");
                        localStorage.removeItem("vetting_search_return_url");
                        this.props.history.push(returnUrl);
                    } else if (!isEmpty(this.state.existingFileNo) || status == 0) {
                        this.props.history.push("/vetting-queue");
                    } else {
                        this.props.history.push("/vetting-login");
                    }
                } else {
                    ToastsStore.error(response.message);
                }
                this.setState({ isLoading: false });
            })
            .catch((err) => {
                console.log(err);
                ToastsStore.error("Failed to save file details. Please try again.");
                this.setState({ isLoading: false });
            });
    };
    fileLogin(id, status) {
        var now = new Date();
        var date = now.toLocaleDateString();
        var time = now.toLocaleTimeString();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        const seconds = now.getSeconds();
        const currenttime = `${hours}:${minutes}:${seconds}`;
        const currentdate = moment(date).format("YYYY-MM-DD");
        const loginuser: any = localStorage.getItem("user1");
        let req = {
            login_time: currenttime,
            login_date: currentdate,
            login_by: JSON.parse(loginuser),
            id: id,
            reason: status == 0 ? "Vetting Login" : "Vetting Scan",
            created_by: JSON.parse(loginuser),
            color: "#aa8986"
        }
        callApi("POST", "time_update.php", req)
            .then(res => res.data)
            .then(response => { });
    }

    resetState = () => {
        const isNewFile = Number(this.props.match.params.id) === 0;
        this.setState({ ...initialState, file_idfk: this.props.match.params.id, isNewFile, isReset: true }, () => {
            this.componentDidMount();
        });
    };

    handleDocumentDetailsChange = (value, index, key, type) => {
        const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', 'Online Encumbrance Certificate'];
        if (key == "docNoYear" && type != "deed") {

            const isValidInput = /^[0-9/-]*$/.test(value);

            if (!isValidInput) {
                // Display an error message or handle the invalid input as needed
                console.error("Invalid input. Please enter only numeric characters, slash, or hyphen.");
                return;
            }
            let baseArray = cloneDeep(this.state.base);
            baseArray[index] = {
                ...baseArray[index],
                [key]: value,
            };
            this.setState({ base: baseArray });
        } else {
            let baseArray = cloneDeep(this.state.base);
            if (key == 'doc_type') {
                if (invalidDocuments.includes(value)) {
                    baseArray[index] = {
                        ...baseArray[index],
                        'docNoYear': '',
                    };
                    this.setState({ base: baseArray });
                }
            }

            baseArray[index] = {
                ...baseArray[index],
                [key]: value,
            };
            this.setState({ base: baseArray });
        }
    };

    handleDocumentFilesChange = (files, index, parentDetails) => {
        const { isGlobalPdfCompress } = this.state;

        const file = files.fileList[0];

        // *** If not a PDF → Direct Upload ***
        if (!file?.type?.includes("pdf")) {
            return this.s3upload(files, index, parentDetails, null);
        }

        // *** If compression disabled → Direct Upload ***
        if (!isGlobalPdfCompress || parentDetails.isPdfCompress != 'on') {
            return this.s3upload(files, index, parentDetails, null);
        }

        // *** If already compressed (avoid double compression) ***
        if (file.alreadyCompressed) {
            return this.s3upload(files, index, parentDetails, null);
        }

        // *** Else compress then upload ***
        this.compressAndUpload(files, index, parentDetails);
    };


    compressAndUpload = async (files, index, parentDetails) => {
        const { deeds, globalPdfCompressQuality, isSroEcPdfCompressQuality, isOnlineEcPdfCompressQuality }: any = this.state;
        this.setState({ isbtnload: true });

        try {
            const file = files.fileList[0];
            const docType = parentDetails.doc_type;

            // Select Compression Quality
            let quality =
                docType === 'SRO Encumbrance Certificate'
                    ? isSroEcPdfCompressQuality || globalPdfCompressQuality
                    : docType === 'Online Encumbrance Certificate'
                        ? isOnlineEcPdfCompressQuality || globalPdfCompressQuality
                        : (deeds?.find((d: any) => d.id === parentDetails.doc_type)?.quality || globalPdfCompressQuality);

            const compressResponse = await compressPdf({
                base64: files.base64,
                quality,
            });

            // Flag file as compressed so it won't repeat
            file.alreadyCompressed = true;

            const uploadObj = {
                ...files,
                base64: compressResponse.compressedBase64,
            };

            this.s3upload(uploadObj, index, parentDetails, compressResponse);
        } catch (err) {
            ToastsStore.error("Failed to compress PDF");
            this.setState({ isbtnload: false });
            console.error(err);
        }
    };

    s3upload = (files, index, parentDetails, compressResponse) => {
        this.setState({ isbtnload: true });
        let baseArray = cloneDeep(this.state.base);
        const fileSize = [...files.fileList].reduce((a, b) => +a + +b.size, 0);
        if (Number(fileSize) > 26214400) {
            ToastsStore.error("File(s) size shouldn't exceed 25 MB");
        } else {
            callApi("POST", "vetting_s3_upload.php", {
                id: Number(this.props.match.params.id),
                rowId: parentDetails.id,
                base: files.base64,
            })
                .then((res) => {
                    if (res.data && res.data.file) {
                        baseArray[index] = {
                            ...baseArray[index],
                            base: res.data.file_name,
                            base_url: res.data.url,
                            doc_path: files.base64,
                            loc_doc_name: files.fileList[0].name,
                            originalSize: compressResponse?.originalSize || '',
                            compressedSize: compressResponse?.compressedSize || '',
                        };
                        this.setState({ base: baseArray });
                        this.setState({ isbtnload: false });
                    } else {
                        ToastsStore.error("Failed to upload file(s)");
                    }
                })
                .catch((err) => {
                    ToastsStore.error("Failed to upload file(s)");
                });
        }
    };

    deleteDocumentDetails = (index) => {
        const baseArray = cloneDeep(this.state.base);
        baseArray.splice(index, 1);
        this.setState({ base: baseArray });
    };
    deleteFile = (index) => {
        const baseArray = cloneDeep(this.state.base);
        baseArray[index] = {
            ...baseArray[index],
            details: {},
            base: "",
            alreadyCompressed: false
        };
        this.setState({ base: baseArray });
    };
    previewDoc = (url) => {
        this.setState({ docToPreview: url });
    };

    addUploadDocument = () => {
        let baseArray = cloneDeep(this.state.base);
        if (this.state.base && this.state.base.length > 0) {
            baseArray.push(this.documentFormat);
        } else {
            baseArray.push(this.firstdocumenttitledeed);
        }
        this.setState({ base: baseArray });
    };

    render() {
        const isFromLogin = this.props?.location?.state ? this.props?.location?.state?.fromLoginFile : false;

        return (
            <div className="pcoded-main-container">
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    <div id="form">
                                        <div className="list-group">
                                            <div className="list-group-item py-3" data-acc-step>
                                                <h5 className="mb-0" data-acc-title>
                                                    Vetting File Login
                                                </h5>
                                                <div>
                                                    <div className="row mt-5">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <Radio.Group
                                                                    disabled={!this.state.isNewFile}
                                                                    value={this.state.logintype}
                                                                    options={[
                                                                        { value: 1, label: "New Login" },
                                                                        { value: 2, label: "Existing Login" },
                                                                    ]}
                                                                    onChange={(e) => {
                                                                        this.resetState();
                                                                        setTimeout(() => {
                                                                            this.setState({ logintype: e.target.value }, () => {
                                                                                if (this.state.logintype == "1") {
                                                                                    this.addUploadDocument();
                                                                                }
                                                                            });

                                                                            this.listBankproduct();
                                                                            this.getDocTypes();
                                                                            this.getCategories();
                                                                        }, 500);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {this.state.logintype == '2' &&
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <label>Existing File No<span style={{ color: "red" }}>*</span></label>
                                                                        </div>
                                                                    </div>
                                                                    <input
                                                                        className={this.state.required && this.state.existingFileNo === '' ? 'form-control is-invalid' : 'form-control'}
                                                                        placeholder="Ex - 81710"
                                                                        name="existingFileNo"
                                                                        type="text"
                                                                        disabled={!this.state.isNewFile && this.state.existingFileNo != ""}
                                                                        value={this.state.existingFileNo}
                                                                        onChange={e => {
                                                                            this.handleChange(e);
                                                                        }}
                                                                        onKeyDown={e => {
                                                                            if (e.key === 'Enter') {
                                                                                if (!isEmpty(this.state.existingFileNo)) this.getFileDetail(this.state.existingFileNo, true);
                                                                            }
                                                                        }}
                                                                        onBlur={() => {
                                                                            if (!isEmpty(this.state.existingFileNo)) this.getFileDetail(this.state.existingFileNo, true);
                                                                        }}
                                                                    />

                                                                    <div className="invalid-feedback">*Required Field</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {this.state.frontOfficeLoading && <>
                                                        <i className="fa fa-spinner fa-spin"></i> Loading...
                                                    </>}
                                                    {(this.state.logintype == "1" || this.state.showForm) && (
                                                        <>
                                                            <VettingLoginForm
                                                                refetch={this.state.isReset}
                                                                initialValue={this.state}
                                                                navigateToDocs={(e: any) =>
                                                                    this.navigateToDocs(e)
                                                                }
                                                                required={this.state.required}
                                                            />
                                                            <div className="text-right">
                                                                {!this.state.searchEdit && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm upload-document-button"
                                                                    onClick={() => this.addUploadDocument()}
                                                                >
                                                                    Add Document +
                                                                </button>
                                                                )}
                                                            </div>
                                                            {!this.state.searchEdit && this.state.base.length > 0 &&
                                                                this.state.base.map((document, index) => (
                                                                    <VettingUploadDocument
                                                                        baseDetails={document}
                                                                        handleDocumentDetailsChange={
                                                                            this.handleDocumentDetailsChange
                                                                        }
                                                                        handleDocumentFilesChange={
                                                                            this.handleDocumentFilesChange
                                                                        }
                                                                        deleteDocumentDetails={
                                                                            this.deleteDocumentDetails
                                                                        }
                                                                        deleteFile={this.deleteFile}
                                                                        previewDoc={this.previewDoc}
                                                                        categoriesList={this.state.categoriesList}
                                                                        deedList={this.state.deeds}
                                                                        index={index}
                                                                        newfile={this.state.isNewFile}
                                                                        isbtnload={this.state.isbtnload}
                                                                        doctype={this.state.doctype}
                                                                        bank_private={this.state.bank_private}
                                                                        state={this.state}
                                                                    />
                                                                ))}
                                                            {/* {isFromLogin && */}
                                                            <div className="my-3">
                                                                {this.state.searchEdit ? (
                                                                    <button
                                                                        type="submit"
                                                                        className="btn btn-success float-right"
                                                                        onClick={(e) => {
                                                                            this.validateRequiredFields(e, this.state.file_status);
                                                                        }}
                                                                        style={{ margin: "16px 0px" }}
                                                                        disabled={this.state.isLoading}
                                                                    >
                                                                        {this.state.isLoading && (
                                                                            <i className="fa fa-spinner fa-spin"></i>
                                                                        )}
                                                                        Save
                                                                    </button>
                                                                ) : (
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-success float-right"
                                                                    onClick={(e) => {
                                                                        this.validateRequiredFields(e, this.state.isNewFile ? -1 : 0);
                                                                    }}
                                                                    style={{ margin: "16px 0px" }}
                                                                    disabled={this.state.isLoading}
                                                                >
                                                                    {this.state.isLoading && (
                                                                        <i className="fa fa-spinner fa-spin"></i>
                                                                    )}
                                                                    Save & Submit
                                                                </button>
                                                                )}
                                                            </div>
                                                            {/* } */}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="modal fade"
                    id="preview-document"
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-lg" role="document" style={{ maxWidth: "1400px" }}>
                        <div className="modal-content" style={{ height: "90vh" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">Document Preview</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={this.state.docToPreview}
                                ></iframe>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-dismiss="modal"
                                    onClick={() => {
                                        this.setState({ docToPreview: "" });
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* THIS FOR OUT REASON MODAL */}
                <div className="modal fade hide in" id="out_reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>
                                <h3 style={{ margin: 'auto', fontSize: '17px' }}>Please Select The Reason For To Close The File.No:{localStorage.getItem("currentfileId")}</h3>
                            </div>
                            <div className="form-group" style={{ width: '74%', margin: 'auto' }}>
                                <select
                                    className="custom-select"
                                    name="outreason"
                                    value={this.state.outreason}
                                    onChange={(e) => this.onchangeReason(e)}
                                    required
                                    id="select1"
                                    style={{ marginTop: '8px' }}
                                >
                                    <option value="select">Select Your Reason</option>
                                    <option value="Query Raised">Query Raised</option>
                                    <option value=" Re-Query Raised"> Re-Query Raised</option>
                                    <option value="Hold ">Hold </option>
                                    <option value="Completed">Completed</option>
                                    <option value="Other">Others</option>

                                </select>
                                {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                            </div>
                            <div className="modal-footer" style={{ marginTop: '27px' }}>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={this.state.isLoading}
                                    onClick={this.outimeGet}
                                    style={{ width: '76px', fontSize: '17px' }}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"
                                    onClick={this.BacktoFile}
                                    style={{ width: '107px', fontSize: '14px', border: '1px solid black', height: '43px' }}
                                > Back To File</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* OTHER REASON MODAL */}
                <div className="modal hide fade in" id="another-reason" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog ">
                        <div className="modal-content" style={{ borderRadius: '10px', boxShadow: '0 0 15px #000' }}>
                            <h5 style={{ marginTop: '31px', textAlign: 'center' }}>Please Type a Reason To Close The File.No: {localStorage.getItem("currentfileId")} </h5>
                            <div className="modal-body" style={{ padding: '30px 23px 29px 24px' }}>

                                {/* <div className="col-md-5"> */}
                                <div className="form-group" style={{ width: '98%', margin: 'auto' }}>
                                    <textarea
                                        className="form-control"
                                        placeholder="Type Your Reason"
                                        name="outreason" onChange={this.onchange} />
                                    {this.state.selectVal ? <p style={{ color: 'red', textAlign: 'center', fontSize: '16px' }}>Please Select Your Reason </p> : null}
                                </div>
                                {/* </div> */}

                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => this.outimeGet()}
                                    style={{ width: '76px', fontSize: '17px' }}
                                    disabled={this.state.isLoading}
                                > {this.state.isLoading ? (
                                    <i className="fa fa-spinner fa-spin"></i>
                                ) : "OK"}</button>
                                <button
                                    type="button"
                                    className="btn btn-outline"

                                    onClick={() => this.previousPop()}
                                    // onClick={this.disableModalHandler}
                                    style={{ width: '76px', fontSize: '17px', border: '1px solid black' }}
                                > Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddVettingFile;
